"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = require("../IconContainer");
const StyledSvg = styled_components_1.default.svg `
  fill: ${(props) => props.theme.palette.teal[0]};
`;
const StyledCheckIcon = styled_components_1.default.path `
  fill: ${(props) => props.theme.palette.status.success};
`;
const ChipCheckIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(StyledSvg, { height: size, viewBox: "0 0 14 14", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("circle", { cx: "7", cy: "7", r: "7" }), (0, jsx_runtime_1.jsx)("svg", { height: "14", viewBox: "0 0 12 10", width: "14", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)(StyledCheckIcon, { "clip-rule": "evenodd", d: "M8 0.801184L2.66668 6.46624L0 3.79956L0.801184 2.99837L2.66668 4.86387L7.19882 0L8 0.801184Z", "fill-rule": "evenodd", transform: "translate(2, 2)" }) })] }));
exports.default = ChipCheckIcon;
//# sourceMappingURL=index.js.map